import OrganizationCreateSetupPage from "@/features/organization/pages/OrganizationCreateSetup";

const OrganizationCreateSetup = () => {
  return <OrganizationCreateSetupPage />;
};

export default OrganizationCreateSetup;
